import * as consts from 'consts/consts';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import Page from '../Layout/Pages/Page';
import GeneralAdministration from '../Organization/GeneralAdministration';

const OrganizationAdministrationPage: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Page title={consts.ADMINISTRATION_ORGANIZATION(formatMessage).name}>
      <GeneralAdministration />
    </Page>
  );
};

export default React.memo(OrganizationAdministrationPage);
